// Get Color name from https://www.color-name.com/hex/4c66bf
export const colors = {
  appBattleshipGrey: '#6c7686',
  appBlue: '#0450d5',
  appBlueyGrey: '#9da3ae',
  appLightBlueGrey: '#3D85C6',
  appBrick: '#d0312a',
  appClearBlue: '#2c93fa',
  appDarkIndigo: '#0b1b36',
  appGreenishTeal: '#2fbc87',
  appGrey: '#f2f2f4',
  appGreyTwo: '#cbd5e0',
  appGreyThree: '#ced1d6',
  appGreyFour: '#cdd5df',
  appIce: '#dcf9ee',
  appIceTwo: '#e9f8f3',
  appLightBlue: '#d0f9f1',
  appLightNavyBlue: '#26527a',
  appLightPink: '#feedf0',
  appOffWhite: '#fff7e5',
  appPale: '#fff4d9',
  appPaleBlue: '#e0e4ec',
  appPaleGrey: '#f7fafc',
  appPaleGreyTwo: '#f3f8ff',
  appPaleGreyFour: '#eaf4fe',
  appPaleGreyThree: '#e9f4ff',
  appPaleLilac: '#e6e7ea',
  appSlate: '#3b485e',
  appVeryLightBlue: '#e5edfb',
  appVeryLightPink: '#fdf4f4',
  appWatermelon: '#f55069',
  appWhite: '#fff',
  appWhiteTwo: '#f6f6f6',
  appYellowOrange: '#fdb400',
  appRed: '#e5635e',
  appWhiteSmoke: '#f5f5f5',
  appKodamaWhite: '#ecf4fd',
  appBlack600: '#0000007a',
  appCoolGrey: '#718096',
  appHanBlue: '#4C66BF',
  appLavenderBlue: '#C7DDFF',
  appPaleCerulean: '#9BB9EE',
  appLightRed: '#FBE9EB',
  appLightGreen: '#ECFDF0',
  imagekitGray: {
    50: "#f7fafc",
    100: "#f7fafc",
    200: "#edf2f7",
    300: "#e1e4eb",
    400: "#cdd5df",
    500: "#a0aec0",
    600: "#718096",
    700: "#4a5568",
    800: "#2d3748",
    900: "#1a202c",
  },
}

export const gradients = {
  whiteTwo: '#f6f6f6',
}

export const spacing = {
  xxs: '4px',
  xs: '8px',
  s: '12px',
  m: '16px',
}

export default {
  colors,
  gradients,
  spacing,
}
